import { Toast, Tooltip } from "./_bootstrap";

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll(".toast")
    .forEach((toastElement) => new Toast(toastElement));

  // Hide the div element with class name 'pdf-reader;
  // if the screen width is smaller than 800px
  const pdfReaderDiv = document.querySelector(".pdf-reader");
  if (window.innerWidth < 960) {
    // Hide the div
    if (pdfReaderDiv) {
      pdfReaderDiv.style.display = "none";
    }
  }
})();
